import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "draivn-help-center-article-block draivn-help-center-article-title drv-heading-2xl drv-pb-11" }
const _hoisted_2 = ["innerHTML"]

import type { IArticle } from "../../types";


export default /*@__PURE__*/_defineComponent({
  __name: 'ArticleContent',
  props: {
    article: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.article.title), 1),
    _createElementVNode("div", {
      class: "draivn-help-center-article-block draivn-help-center-article-content",
      innerHTML: _ctx.article.content
    }, null, 8, _hoisted_2)
  ], 64))
}
}

})